import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { ActionTypeEnum } from 'src/app/enum/action-type-enum.enum';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { TemplateRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { UtilityService } from 'src/app/services/utility.service';
import { CustomField } from 'src/app/model/custom-field.modals';
import {map} from 'rxjs/operators';

type RequestStatus = "Saving.." | "Save" | "Updating.." | "Update";
@Component({
  selector: 'app-custom-field',
  templateUrl: './custom-field.component.html',
  styleUrls: ['./custom-field.component.css']
})
export class CustomFieldComponent implements OnInit {
  displayedColumns: string[] = ['name', 'description', 'createdBy', 'createdOn', 'Actions'];
  isLoading: boolean;
  dataSource: MatTableDataSource<any>;
  noData: any;
  organization: any;
  application_name: any;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  modalRef: BsModalRef;
  fieldModal: CustomField=new CustomField(); // { name: string, description: string, fieldType: Number, isRequired: boolean } = { name: "", description: "", fieldType: null, isRequired: false };
  requestStatus: RequestStatus = "Save";
  @ViewChild("addFieldTemplate") uiModal: TemplateRef<any>;
  Mode: "Add" | "UPDATE" = "Add";
  buttonLabel: string;


  constructor(
    private modalService: BsModalService, private service: UtilityService, private toasterService: ToastrService
  ) {
    this.application_name = "Educian";
    this.organization = localStorage.getItem("org_id");
    this.fieldModal.isRequired=false;
    this.fieldModal.fieldType=null;
    this.fieldModal.isVisible=false;
    this.fieldModal.organization=this.organization;
  }

  ngOnInit() {
    this.fetchCustomFields();
  }
  onAddClick(template: TemplateRef<any>) {
    let config = { backdrop: true, ignoreBackdropClick: true };
    this.modalRef = this.modalService.show(template, config);
     this.fieldModal.clear();
  }
  onIsRequiredToggle(event) {
    if (!event) {
      this.fieldModal.isRequired = false;
    }
  }
  onIsVisibilityToggle(event) {
    if (!event) {
      this.fieldModal.isVisible = false;
      this.fieldModal.isRequired=false;
      this.fieldModal.default="";
      this.fieldModal.description="";
    }
  }
  onSave(form: NgForm) {
    this.requestStatus = "Saving..";
    this.service.saveCustomField(this.fieldModal).subscribe((res: any) => {
      if (!res.error) {
        this.toasterService.success(res.message);
        this.requestStatus = "Save";
        this.modalRef.hide();
        this.fieldModal.clear();
        this.fetchCustomFields();
      } else {
        this.toasterService.success(res.message);
        this.requestStatus = "Save";

      }
    })
  }
  onDelete(id:any) {
    this.service.deleteCustomField(id).subscribe((res: any) => {
      if (!res.error) {
        this.toasterService.success(res.message);
        this.fetchCustomFields();
      } else {
        this.toasterService.success(res.message);

      }
    })
  }
  onUpdate() {
    this.requestStatus = "Updating.."
    this.service.updateCustomField(this.fieldModal).subscribe((res: any) => {
      if (!res.error) {
        this.fetchCustomFields();
        this.toasterService.success(res.message);
        this.modalRef.hide();
        this.fieldModal.clear();
        this.requestStatus = "Save";
      } else {
        this.toasterService.success(res.message);
        this.requestStatus = "Update";

      }
    })
  }
  onEditClick(id: any) {
    this.requestStatus="Update";
    this.fieldModal.clear();
    this.service.fetchCustomField(id).subscribe((res: any) => {
      this.onAddClick(this.uiModal);
      this.fieldModal.set(res.field);
    })
  }
  fetchCustomFields() {
    this.isLoading = true;
    this.service.fetchCustomFields(this.organization).subscribe((res: any) => {
      this.dataSource = new MatTableDataSource<any>(res.fields);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.isLoading = false
      this.noData = this.dataSource.connect().pipe(map(data => data.length === 0));

    })
  }
  applyFilter(event: Event) {
    this.noData = this.dataSource.connect().pipe(map(data => data.length === 0));
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
